import Decimal from 'decimal'

//加
Number.prototype.add = function(value) {
    return new Decimal(this).add(new Decimal(value)).toNumber()
}

//减
Number.prototype.sub = function(value) {
    return new Decimal(this).sub(new Decimal(value)).toNumber()
}

//乘
Number.prototype.mul = function(value) {
    return new Decimal(this).mul(new Decimal(value)).toNumber()
}

//除
Number.prototype.div = function(value) {
    return new Decimal(this).div(new Decimal(value)).toNumber()
}



// WEBPACK FOOTER //
// ./src/config/decimal.js